import { useNavigate, useLocation } from 'react-router-dom';
import { IconChevronDown, IconLogout } from '@tabler/icons-react';
import { Center, Group, Menu, Button } from '@mantine/core';
import { useState, useEffect } from 'react';
import LogotipoColor from '../../assets/logos/logotipo_color.svg';
import CambiarEntitat from '../../assets/icons/cambiar_entitat.svg';
import { LogoutModal } from '../Modals/LogoutModal';
import classes from './HeaderSimple.module.css';

// Props para el componente HeaderSimple
interface HeaderSimpleProps {
  userName?: string;
  // userRole?: string;
  // entityName?: string;
  onEntityChange?: (entitatName: string) => void;
  logOut: () => void;
  entitatsData: any[];
  entity: any;
  setEntity: any;
  tramits: boolean;
  trameses: boolean;
  setCambiarEntitatModalOpened: any;
}

function getCookie(cname: any) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c: any = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export function HeaderSimple({
  userName,
  // userRole = "El meu rol", 
  // entityName = "Nom de l'Entitat",
  onEntityChange,
  logOut,
  entitatsData,
  entity,
  setEntity,
  tramits,
  trameses,
  setCambiarEntitatModalOpened
}: HeaderSimpleProps) {
  // Estado para el menú móvil (hamburguesa)
  // const [opened, { toggle }] = useDisclosure(false);
  // Estado para la modal de logout
  const [logoutModalOpened, setLogoutModalOpened] = useState(false);
  // Estado para la modal de cambiar entidad
  // const [cambiarEntitatModalOpened, setCambiarEntitatModalOpened] = useState(false);
  const [links, setLinks] = useState([] as any);
  // Hooks de React Router para navegación y ubicación
  const navigate = useNavigate();
  const location = useLocation();

  // Función para navegar a una nueva página
  const handleLinkClick = (link: string) => {
    navigate(link);
  };

  useEffect(() => {
    if (entitatsData.length === 1) {
      setEntity(entitatsData[0]);
      setCambiarEntitatModalOpened(false);
    }
    else {
      let x = getCookie("entityOV");
      if(x != null && x != "") {
        setEntity(JSON.parse(x));
        setCambiarEntitatModalOpened(false);
      }
      else {
        setCambiarEntitatModalOpened(true);
      }
    }
  }, []);
  useEffect(() => {
    // Configuración del menú principal con enlaces y submenús
    let linksAux: any[] = [{ link: '/dashboard', label: 'Dashboard' }];

    if (tramits) {
      linksAux.push({
        link: '',
        label: 'Tràmits',
        links: [ // Submenú con opciones desplegables
          { link: '/tramits/iniciar-nou', label: 'Iniciar Nou' },
          { link: '/tramits/consultar', label: 'Consultar' }
        ]
      });
    }

    if (trameses) {
      linksAux.push({
        link: '',
        label: 'Trameses',
        links: [
          { link: '/trameses/iniciar-nova', label: 'Iniciar Nova' },
          { link: '/trameses/consultar', label: 'Consultar' },
          { link: '/trameses/quadre-control', label: 'Quadre de Control de Trameses' }
        ]
      });
    }

    linksAux.push({ link: '/comunicaciones', label: 'Comunicacions' }, { link: '/documentacion', label: 'Documentació' });

    setLinks(linksAux);
  }, [])

  const items = links.map((link: any) => {
    // Crear elementos del submenú si existen
    const menuItems = link.links?.map((item: any) => (
      <Menu.Item key={item.link} onClick={() => handleLinkClick(item.link)}>
        {item.label}
      </Menu.Item>
    ));

    // Si tiene submenú, renderizar como Menu desplegable
    if (menuItems) {
      // Verificar si algún elemento del submenú está activo
      // Comprueba tanto la ruta exacta como si la ruta actual pertenece a la misma sección
      const isSubMenuActive = link.links?.some((subItem: any) => {
        const exactMatch = location.pathname === subItem.link;
        // Extraer la sección base de la ruta (ej: /tramits o /trameses)
        const sectionMatch = subItem.link.split('/')[1] &&
          location.pathname.startsWith(`/${subItem.link.split('/')[1]}`);
        return exactMatch || sectionMatch;
      });

      return (
        <Menu key={link.label} trigger="hover" transitionProps={{ exitDuration: 0 }} withinPortal>
          <Menu.Target>
            <a
              href={link.link}
              className={classes.link}
              data-active={isSubMenuActive || undefined}
              onClick={(event) => {
                event.preventDefault();
                navigate(link.link);
              }}
            >
              <Center>
                <span className={classes.linkLabel}>{link.label}</span>
                <IconChevronDown size={14} stroke={1.5} />
              </Center>
            </a>
          </Menu.Target>
          <Menu.Dropdown>{menuItems}</Menu.Dropdown>
        </Menu>
      );
    }

    // Si no tiene submenú, renderizar como enlace simple
    const isActive = location.pathname === link.link;
    return (
      <a
        key={link.label}
        href={link.link}
        className={classes.link}
        data-active={isActive || undefined}
        onClick={(event) => {
          event.preventDefault();
          handleLinkClick(link.link);
        }}
      >
        {link.label}
      </a>
    );
  });

  return (
    <header className={`${classes.header} app-header`}>
      <div className={classes.inner}>
        {/* Logo de AFA */}
        <Group visibleFrom="lg">
          <div className={classes.logo}>
            <img src={LogotipoColor} alt="AFA Logo" />
          </div>
        </Group>
        {/* Sección derecha: menú principal + botón de usuario */}
        <div className={classes.rightSection}>
          {/* Menú principal - visible en pantallas grandes */}
          <Group gap={5}
          // visibleFrom="lg"
          >
            {items}
          </Group>

          {/* Botón de usuario - visible en pantallas grandes */}
          <Group gap={16}
          // visibleFrom="lg"
          >
            <button
              className={classes.userButton}
              onClick={() => setCambiarEntitatModalOpened(true)}
              type="button"
              disabled={entitatsData.length <= 1}
            >
              <Center>
                <img
                  src={CambiarEntitat}
                  alt="Cambiar Entidad"
                  className={classes.userIconWhite}
                  style={{ width: 16, height: 16, marginRight: '8px' }}
                />
                <span className={classes.linkLabel}>
                  {/* {userName} - {userRole} - {entityName} */}
                  {userName} - {entity?.lookupValue || ''}
                </span>
              </Center>
            </button>

            <Button
              variant="light"
              color="brand"
              radius={"md"}
              leftSection={<IconLogout size={16} />}
              onClick={() => setLogoutModalOpened(true)}>
              Logout
            </Button>
          </Group>
        </div>

        {/* Botón hamburguesa - visible en tablets y móviles */}
        {/* <Burger opened={opened} onClick={toggle} size="sm" hiddenFrom="lg" /> */}
      </div>

      {/* Modal de logout */}
      <LogoutModal
        opened={logoutModalOpened}
        onClose={() => setLogoutModalOpened(false)}
        logOut={() => logOut()}
      />

      {/* Modal de cambiar entidad
      <CambiarEntitatModal
        ENTITATS_DATA={entitatsData}
        opened={cambiarEntitatModalOpened}
        onClose={() => setCambiarEntitatModalOpened(false)}
        currentEntitat={entity != null ? entity.lookupValue : ''}
        onSubmit={(entitatName: string) => {
          if (onEntityChange) {
            onEntityChange(entitatName);
          }
          setCambiarEntitatModalOpened(false);
        }}
      /> */}
    </header>
  );
}
